/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getTickerAuctioneerLotState } from '../fn/ticker-auctioneer-lot-state/get-ticker-auctioneer-lot-state';
import { GetTickerAuctioneerLotState$Params } from '../fn/ticker-auctioneer-lot-state/get-ticker-auctioneer-lot-state';
import { TickerAuctioneerLotStateDto } from '../models/ticker-auctioneer-lot-state-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedTickerAuctioneerLotStateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTickerAuctioneerLotState()` */
  static readonly GetTickerAuctioneerLotStatePath = '/api/ticker/lot-auctioneer-states/{id}';

  /**
   * Gets the auctioneer state of lot by its id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTickerAuctioneerLotState()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickerAuctioneerLotState$Response(params: GetTickerAuctioneerLotState$Params, context?: HttpContext): Observable<StrictHttpResponse<TickerAuctioneerLotStateDto>> {
    return getTickerAuctioneerLotState(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the auctioneer state of lot by its id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTickerAuctioneerLotState$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickerAuctioneerLotState(params: GetTickerAuctioneerLotState$Params, context?: HttpContext): Observable<TickerAuctioneerLotStateDto> {
    return this.getTickerAuctioneerLotState$Response(params, context).pipe(
      map((r: StrictHttpResponse<TickerAuctioneerLotStateDto>): TickerAuctioneerLotStateDto => r.body)
    );
  }

}
